import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import Box from '../../../../Global/Box'
import Loader from '../../../../Global/Spinner'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import { GET_AVERAGE_TIME_OF_ATTENTION } from '../../../../../graphql/Catalog/ReportsQueries/reportsQueries'

const GetAverageTimeOfAttention = ({ filters }) => {
  //STATES:
  const [dataResp, setDataResp] = useState([])

  //QUERIES:
  const { loading, error, data } = useQuery(GET_AVERAGE_TIME_OF_ATTENTION, {
    variables: {
      filters: { dateFrom: filters.dateFrom, dateTo: filters.dateTo },
    },
    fetchPolicy: 'cache-and-network',
  })

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      setDataResp(data?.getAverageTimeOfAttention)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  if (loading) return <Loader />

  return (
    <Box
      classNameHeader="card-header py-1 bg-info"
      contentHeader={
        <h3 className="card-title pl-3 mt-0">
          <div className="text-white">
            <i className={`fas fa-percent pr-2`} />
            Tiempo promedio de atención
          </div>
        </h3>
      }
      content={
        <>
          {!dataResp?.day && !dataResp?.time && (
            <div className="alert alert-default-info p-1">
              No hay resultados
            </div>
          )}
          {dataResp?.day && <h2 className="text-bold">{dataResp.day}</h2>}
          {dataResp?.time && <h2 className="text-bold">{dataResp.time}</h2>}
        </>
      }
    />
  )
}

export default GetAverageTimeOfAttention
